import { createRoute } from '@tanstack/react-router';
import { Route as parent } from './site.tsx';
export const Route = createRoute({ getParentRoute: () => parent, path: 'forms/$formId' }).lazy(() =>
  import('./site-form.lazy.tsx').then((module) => module.Route),
);
